import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Layout from './components/Layout';
import RequireAuth from './components/RequireAuth';
import Dashboard from './pages/Dashboard';
import HomePage from './pages/HomePage';
import LeadsPage from './pages/LeadsPage';
import AccountsPage from './pages/AccountsPage';
import ContactsPage from './pages/ContactsPage';
import TasksPage from './pages/TasksPage';
import ProjectsPage from './pages/ProjectsPage';
import ProposalsPage from './pages/ProposalsPage';
import KEEPage from './pages/KEEPage';
import RoadmapPage from './pages/RoadmapPage';
import SoulPage from './pages/SoulPage';
import UsageBillingPage from './pages/UsageBillingPage';
import AdminPanel from './pages/AdminPanel';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import NotFound from './components/NotFound';
import FeedbackAdminPage from './pages/FeedbackAdminPage';
import ProposalBuilderPage from './pages/ProposalBuilderPage';
import ShipmentsPage from './pages/ShipmentsPage';
import ShipmentDetailPage from './pages/ShipmentDetailPage';
import InvestmentsPage from './pages/InvestmentsPage';
import BooksPage from './pages/BooksPage';
import PartnerCompPage from './pages/PartnerCompPage';
import BidsPage from './pages/BidsPage';
import ConcriaMeetPage from './pages/ConcriaMeetPage';
import ConcriaOyPage from './pages/ConcriaOyPage';
import CatalogPage from './pages/CatalogPage';
import QuotesPage from './pages/QuotesPage';
import QuoteEditorPage from './pages/QuoteEditorPage';
import OrdersPage, { OrderDetailPage } from './pages/OrdersPage';
import InvoicesPage, { InvoiceDetailPage } from './pages/InvoicesPage';
import MarketingPage from './pages/MarketingPage';

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          {/* Public routes — no auth required */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Protected routes — wrapped in RequireAuth. Module-specific
              routes (contracts, crm, tasks, costs, modules, etc.) inject
              their own routes during module deploy; canonical only mounts
              platform-infrastructure routes. */}
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<HomePage />} />
            <Route path="/overview" element={<Dashboard />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/accounts" element={<AccountsPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/proposals" element={<ProposalsPage />} />
            <Route path="/shipments" element={<ShipmentsPage />} />
            <Route path="/shipments/:id" element={<ShipmentDetailPage />} />
            <Route path="/investments" element={<InvestmentsPage />} />
            <Route path="/books" element={<BooksPage />} />
            <Route path="/partner-comp" element={<PartnerCompPage />} />
            <Route path="/bids" element={<BidsPage />} />
            <Route path="/concria-meet" element={<ConcriaMeetPage />} />
            <Route path="/concria-oy" element={<ConcriaOyPage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/quotes" element={<QuotesPage />} />
            <Route path="/quotes/:id" element={<QuoteEditorPage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/:id" element={<OrderDetailPage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/invoices/:id" element={<InvoiceDetailPage />} />
            <Route path="/marketing" element={<MarketingPage />} />
            <Route path="/kee" element={<KEEPage />} />
            <Route path="/roadmap" element={<RoadmapPage />} />
            <Route path="/soul" element={<SoulPage />} />
            <Route path="/billing" element={<UsageBillingPage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/feedback-admin" element={<FeedbackAdminPage />} />
            <Route path="/proposal-builder/:leadId" element={<ProposalBuilderPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
